import facebookIconGrey from "assets/icons/facebookGrey.svg";
import {
  default as facebookIcon,
  default as facebookIconCircle,
} from "assets/icons/facebookIconCircle.svg";
import {
  default as instagramIcon,
  default as instagramIconCircle,
} from "assets/icons/instagramDefault.svg";
import instagramIconGrey from "assets/icons/instagramIconGrey.svg";
import linkedinIconGrey from "assets/icons/linkedinGrey.svg";
import {
  default as linkedinIcon,
  default as linkedinIconCircle,
} from "assets/icons/linkedinIconCircle.svg";
import tiktokCircle from "assets/icons/tiktok-circle.svg";
import twitterIconGrey from "assets/icons/twitterGrey.svg";
import tiktokIcon from "assets/icons/tiktokIcon.svg";
import tiktokIconGrey from "assets/icons/tiktokGrey.svg";
import {
  default as twitterIcon,
  default as twitterIconCircle,
} from "assets/icons/twitterIconCircle.svg";
import youtubeIconGrey from "assets/icons/youtubeGrey.svg";
import {
  default as youtubeIcon,
  default as youtubeIconCircle,
} from "assets/icons/youtubeIconCircle.svg";
import facebookWhite from "assets/icons/facebook_white.svg";
import instagramWhite from "assets/icons/instagram_white.svg";
import twitterWhite from "assets/icons/twitter_white.svg";
import linkedinWhite from "assets/icons/linkedin_white.svg";
import tiktokWhite from "assets/icons/tiktok_white.svg";
import youtubeWhite from "assets/icons/youtube_white.svg";
import pinterestWhite from "assets/icons/pinterest_white.svg";
import threadsWhite from "assets/icons/threads_white.svg";
import PlayIcon from "assets/icons/play_icon_two.svg";
import StoryIcon from "assets/icons/story_video_icon.svg";
import ReelIcon from "assets/icons/reel_icon.svg";
import videoIndicator from "assets/icons/video-indicator.svg";
import pinterestIcon from "assets/icons/pinterest-icon.svg";
import threadIcon from "assets/icons/threads-icon.svg";
import pinterestGrey from "assets/icons/pinterestGrey.svg";
import threadGrey from "assets/icons/threadsGrey.svg";

export const supportedPlatforms = [
  "facebook",
  "instagram",
  "twitter",
  "linkedin",
  "tiktok",
  "youtube",
  "pinterest",
  "meta_threads",
];

export const socialIconsGrey = {
  facebook: facebookIconGrey,
  linkedin: linkedinIconGrey,
  twitter: twitterIconGrey,
  youtube: youtubeIconGrey,
  instagram: instagramIconGrey,
  tiktok: tiktokIconGrey,
  pinterest: pinterestGrey,
  meta_threads: threadGrey,
};

export const socialIconsWhite = {
  facebook: facebookWhite,
  linkedin: linkedinWhite,
  twitter: twitterWhite,
  youtube: youtubeWhite,
  instagram: instagramWhite,
  tiktok: tiktokWhite,
  pinterest: pinterestWhite,
  meta_threads: threadsWhite,
};

export const socialIcons = {
  default: {
    facebook: facebookIcon,
    twitter: twitterIcon,
    linkedin: linkedinIcon,
    youtube: youtubeIcon,
    instagram: instagramIcon,
    tiktok: tiktokIcon,
    pinterest: pinterestIcon,
    meta_threads: threadIcon,
  },
  circle: {
    facebook: facebookIconCircle,
    twitter: twitterIconCircle,
    linkedin: linkedinIconCircle,
    youtube: youtubeIconCircle,
    instagram: instagramIconCircle,
    tiktok: tiktokCircle,
    pinterest: pinterestIcon,
    meta_threads: threadIcon,
  },
  grey: socialIconsGrey,
};

export const oldFileLimits = {
  // size is in mb
  // totalMedia is total number of media allowed to be posted
  facebook: { image: 30, video: 4000, reel: 4000, totalMedia: 10 },
  instagram: { image: 8, video: 1000, reel: 1000, story: 100, totalMedia: 10 },
  linkedin: { image: 5, video: 200, totalMedia: 10 },
  twitter: { image: 5, gif: 15, video: 512, totalMedia: 4 },
  youtube: { video: 256000, shorts: 256000, totalMedia: 1 },
  tiktok: { image: 100, video: 4000, totalMedia: 10 },
  pinterest: { image: 5, totalMedia: 5 },
  meta_threads: { image: 5, gif: 15, video: 512, totalMedia: 4 },
};

export const fileLimits = {
  // size is in mb
  // totalMedia is total number of media allowed to be posted
  facebook: { image: 16, video: 4000, reel: 4000, totalMedia: 10 },
  instagram: { image: 16, video: 1000, reel: 1000, story: 100, totalMedia: 10 },
  linkedin: { image: 10, video: 200, totalMedia: 10 },
  twitter: { image: 10, gif: 15, video: 512, totalMedia: 4 },
  youtube: { video: 256000, shorts: 256000, totalMedia: 1 },
  tiktok: { image: 100, video: 4000, totalMedia: 10 },
  pinterest: { image: 10, totalMedia: 1 },
  meta_threads: { image: 10, gif: 15, video: 512, totalMedia: 4 },
};

export const limits = {
  facebook: 5000,
  linkedin: 3000,
  twitter: 280,
  instagram: 2200,
  youtube: {
    title: 92,
    description: 5000,
  },
  tiktok: 2200,
  threads: 500,
  meta_threads: 500,
  pinterest: {
    title: 100,
    content: 500,
  },
};

export const mediaIcon = {
  shorts: videoIndicator,
  story: StoryIcon,
  reel: ReelIcon,
  post: PlayIcon,
};

export const youtubeVisibilityOptions = ["Public", "Private", "Unlisted"];

export const youtubeAudienceOptions = [
  "Yes, it's a video made for kids",
  "No, it's not a video made for kids",
];
